import { render, staticRenderFns } from "./ShopEdit.vue?vue&type=template&id=25a5cf1e&scoped=true&"
import script from "./ShopEdit.vue?vue&type=script&lang=js&"
export * from "./ShopEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShopEdit.vue?vue&type=style&index=0&id=25a5cf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5cf1e",
  null
  
)

export default component.exports